import { render, staticRenderFns } from "./user-develop.vue?vue&type=template&id=3d4aede7&scoped=true"
import script from "./user-develop.vue?vue&type=script&lang=js"
export * from "./user-develop.vue?vue&type=script&lang=js"
import style0 from "./user-develop.vue?vue&type=style&index=0&id=3d4aede7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4aede7",
  null
  
)

export default component.exports